import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const GiftIcon = ({ size = 16, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="8" width="18" height="4" />
    <path d="M5 12v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8" />
    <path d="M12 8v13" />
    <path d="M12 8a3 3 0 1 0-3-5c1.5 1 2.5 3 3 5a3 3 0 1 1 3-5c-1.5 1-2.5 3-3 5z" />
  </svg>
)
